export const getCurrentUserState = state => state.coursesCurrentUser;
export const getHomeState = state => state.coursesHome;
export const getSpecificCourseState = state => state.coursesSpecificCourse;
export const getCheckoutState = state => state.coursesCheckout;
export const getGiftCardCheckoutState = state => state.coursesGiftCardCheckout;
export const getWatchLessonState = state => state.watchLesson;
export const getProfileState = state => state.coursesProfile;
